/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-11-22 09:33:18
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  setInstallFile: '请配置安装文件',
  uploadApp: '上传安装包',
  uploadFromLocal: '本地电脑上传',
  uploadFromLocalTip: '从本地工作电脑上传文件',
  uploadFromService: '服务器安装',
  uploadFromServiceTip: '文件已拷贝至supOS服务器',
  installPathTip: '系统将安装至 /home/supos/supos/opt/supos',
  installPath: '安装包位置',
  installPathTip2: '请将安装包放置在 /home/supos/supos/downloads/',
  existTitleTip: '有组件已在上传中',
  existContentTip: '请确认',
  sure: '确认',
  uploadRequiredModuleTitleTip: '请上传符合要求的包',
  fileCheckTip: '所选文件非supOS安装文件，或文件名称不符合要求，无法上传，请确认。',
  refresh: '刷新列表',
  selectable: '可选择',
  selected: '已选择',
  null: '暂无数据',
});
